import { FC } from 'react';
import { FormNumberFieldProps } from './types';
import { FormNumberField } from '../FormNumberField';
import { CalculatorHeading } from '../CalculatorHeading';
import { CalculatorText } from '../CalculatorText';

export const CalculatorNumberField: FC<FormNumberFieldProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  numericFormatProps,
  textFieldProps,
  shouldShowAdornment = false,
}) => {
  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      <CalculatorText labelKey={textKey} />
      <FormNumberField
        name={name}
        className={'mt-2'}
        rules={rules}
        shouldShowAdornment={shouldShowAdornment}
        numericFormatProps={numericFormatProps}
        textFieldProps={{
          ...textFieldProps,
          inputProps: { min: 0 },
          InputProps: {
            placeholder: textFieldProps?.placeholder,
          },
        }}
      />
    </div>
  );
};
